import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        content: {
            borderRadius: 'large.base',
            padding: remCalc(26),
            gap: remCalc(22),
        },
        header: {
            padding: 0,
            paddingBottom: remCalc(24),
        },
        body: {
            padding: 0,
            paddingBottom: remCalc(24),
        },
        footer: {
            padding: 0,
        },
        cta: {
            _focusVisible: {
                color: 'white',
            },
        },
    },
}
